import logo from './logo.svg';
import './App.css';
import Routs from './routing/routs';

function App() {
  return (
     <Routs/>
  );
}

export default App;
